import { render, staticRenderFns } from "./search-bar copy.vue?vue&type=template&id=6e4fe78c&scoped=true&"
import script from "./search-bar copy.vue?vue&type=script&lang=js&"
export * from "./search-bar copy.vue?vue&type=script&lang=js&"
import style0 from "./search-bar copy.vue?vue&type=style&index=0&id=6e4fe78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4fe78c",
  null
  
)

export default component.exports